import { PersonPostionGroup } from '@aibees/elephant/feature/search-table-people/types';
import { intervalToDurationStrict } from '@aibees/shared/utils';

export const currentCompanyDuration = (item: PersonPostionGroup) => {
  if (!item.date?.start) return '';

  const startDate = new Date(item.date?.start || 0).getTime();
  const endDate = item.date?.end
    ? new Date(item.date.end || 0).getTime()
    : new Date().getTime();

  const { years, months } = intervalToDurationStrict(startDate, endDate);

  let formatedJobDuration = '';

  if (years) {
    formatedJobDuration = years + (years > 1 ? ' Years' : ' Year');
  }
  if (years && months) {
    formatedJobDuration += ', ';
  }
  if (months) {
    formatedJobDuration += months + (months > 1 ? ' Months' : ' Month');
  }

  return formatedJobDuration;
};
